import List from "./List";

export default class OverviewList extends List {

    constructor() {
        super();
    }

    private 
}